// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OzA+s","hidden":"styles_hidden__MCAAU","buyButton":"styles_buyButton__2BMQs","sellButton":"styles_sellButton__B+tTc"};